import React, { useState, useEffect } from "react";

import ContractHoldersGroups from "./ContractHoldersGroups/ContractHoldersGroups.jsx";
import ContractHoldersDetails from "./ContractHoldersDetails/ContractHoldersDetails.jsx";
import ProgramManagers from "./ProgramManagers/ProgramManagers.jsx";
import SmallBusiness from "./SmallBusiness/SmallBusiness.jsx";
import BusinessBreakdown from "./BusinessBreakdown/BusinessBreakdown.jsx";

import { getDisplayType } from "../../util/contractHoldersList.js";

import "../../styles/contractHolders.less";

import {
  PAGE_TYPE_CH_GROUP,
  PAGE_TYPE_DETAIL,
  PAGE_TYPE_PROGRAM_MANAGERS,
  PAGE_TYPE_SMALL_BUSINESS,
  PAGE_TYPE_BUSINESS_BREAKDOWN,
} from "../../constants.js";

export default function ContractHolders() {
  const [path, setPath] = useState(window.location.hash);
  const [fetchError, setFetchError] = useState(false);

  //listen for hash changes to update path state
  useEffect(() => {
    window.onhashchange = () => {
      setPath(window.location.hash);
    };
  }, []);

  //update document title
  useEffect(() => {
    const { type } = getDisplayType(path);
    // detail page title updates is handled in ContractHoldersDetails.jsx b/c CH name is needed
    switch (type) {
      case PAGE_TYPE_CH_GROUP:
        document.title = "NASA SEWP Contract Holders";
        break;

      case PAGE_TYPE_PROGRAM_MANAGERS:
        document.title = "NASA SEWP Contract Holders - Program Managers";
        break;

      case PAGE_TYPE_SMALL_BUSINESS:
        document.title = "NASA SEWP Contract Holders - Small Businesses";
        break;

      case PAGE_TYPE_BUSINESS_BREAKDOWN:
        document.title = "NASA SEWP Contract Holders - Small Business Breakdown";
        break;
    }
  }, [path]);

  const display = getDisplayType(path);
  let content;

  if (fetchError) {
    content = <div>Error loading data.</div>;
  } else if (display.type === PAGE_TYPE_DETAIL) {
    content = <ContractHoldersDetails path={path} setFetchError={setFetchError}/>;
  } else if (display.type === PAGE_TYPE_CH_GROUP) {
    content = <ContractHoldersGroups setFetchError={setFetchError}/>;
  } else if (display.type === PAGE_TYPE_PROGRAM_MANAGERS) {
    content = <ProgramManagers setFetchError={setFetchError}/>;
  } else if (display.type === PAGE_TYPE_SMALL_BUSINESS) {
    content = <SmallBusiness setFetchError={setFetchError}/>;
  } else if (display.type === PAGE_TYPE_BUSINESS_BREAKDOWN) {
    content = <BusinessBreakdown setFetchError={setFetchError}/>;
  } else {
    content = <div>Page not found.</div>;
  }

  return <div id="contract-holders-wrapper" className="container-fluid">{content}</div>;
}